import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreatePersonnelMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ params }) => {
      const response = await axios.post('/personnel', { personnel: params });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['assignableCompanyRoles']);
      queryClient.invalidateQueries(['personnel']);

      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes('assignablePersonnelSearches') ||
          query.queryKey.includes('companyRoleSearches') ||
          query.queryKey.includes('teamSearches'),
      });
    },
  });
}
